import { MessageLevel } from 'types/types';

export const getVariant = (level: MessageLevel) => {
  switch (level) {
    case MessageLevel.Success:
      return 'success';
    case MessageLevel.Warning:
      return 'warning';
    case MessageLevel.Error:
      return 'error';
    case MessageLevel.Information:
    default:
      return 'info';
  }
};
